import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPermissions } from "../store/userSlice";
import { isRouteAccessible } from "../utils/permissionUtils";

/**
 * Component to protect routes based on permissions
 */
const PermissionRoute = ({ element, requiredPermission }) => {
  const permissions = useSelector(selectPermissions);
  
  if (!isRouteAccessible(permissions, requiredPermission)) {
    // Redirect to unauthorized page or dashboard if user lacks permission
    return <Navigate to="/unauthorized" replace />;
  }
  
  return element;
};

export default PermissionRoute;